import React from "react";

const lazyWithPreload = <T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) => {
  const LazyComponent = React.lazy(factory);

  return Object.assign(LazyComponent, {
    preload: () => factory(),
  });
};

export default lazyWithPreload;
